<nb-card>
    <nb-card-body>
        <div class="match-participants" *ngIf="registers?.tenistas">
            <div class="match-participant">
                <div class="match-participant-avatar">
                    <img [src]="registers.tenistas[0].url_avatar" [alt]="registers.tenistas[0].nome" />
                </div>
                <p class="match-participant-name">{{ registers.tenistas[0].nome }}</p>
            </div>
            <div class="match-participants-vs">
                <span>- vs -</span>
            </div>
            <div class="match-participant">
                <div class="match-participant-avatar">
                    <img [src]="registers.tenistas[1].url_avatar" [alt]="registers.tenistas[1].nome" />
                </div>
                <p class="match-participant-name">{{ registers.tenistas[1].nome }}</p>
            </div>
        </div>
        <div *ngIf="registers?.indicadores" class="mt-3">
            <nb-progress-bar
                *ngIf="registers?.indicadores[6]"
                status="success"
                size="tiny"
                [value]="registers.indicadores[6].perform.lado_1"
            ></nb-progress-bar>
            <div class="d-flex justify-content-between align-items-center mt-3">
              <span class="paragraph-2">{{ registers.indicadores[6].perform.lado_1 }}</span>
              <span class="text-center caption mb-0">{{ registers.indicadores[6].label }}</span>
              <span class="paragraph-2">{{ registers.indicadores[6].perform.lado_2 }}</span>
            </div>
        </div>
    </nb-card-body>
    <div class="indicators px-4">
        <div
            class="d-flex justify-content-between align-items-center my-2"
            *ngFor="let indicator of registers?.indicadores"
        >
            <span>{{ indicator.perform.lado_1 }}</span>
            <span>{{ indicator.label }}</span>
            <span>{{ indicator.perform.lado_2 }}</span>
        </div>
    </div>
</nb-card>
